<template>
  <div>
    <vxe-table row-id="id" :data="datalist" align="left">
      <vxe-table-column field="name" show-overflow min-width="120" title="名称"></vxe-table-column>
      <vxe-table-column field="identifier" show-overflow min-width="120" title="标识符"></vxe-table-column>
      <vxe-table-column field="data_value" show-overflow min-width="120" title="数据值"></vxe-table-column>
      <vxe-table-column field="data_type" show-overflow min-width="120" title="数据类型"></vxe-table-column>
    </vxe-table>
    <v-pagination v-if="total" @change-page="changePage" @change-size="changeSize" :total="total" name="page-basic" is-show-total is-change-size is-input-page :current-page="this.currentPage"></v-pagination>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    devKey: {}
  },
  data() {
    return {
      datalist: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  created() {
    this.getData();
  },

  methods: {
    changePage(page) {
      this.currentPage = Number(page);
      this.getData();
    },
    changeSize(size) {
      this.pageSize = Number(size);
      this.currentPage = 1;
      this.getData();
    },
    async getData() {
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
        dev_key: this.devKey,
        page_num: this.currentPage,
        page_size: this.pageSize
      };
      const res = await this.$getData('/td/td-iot-api/iot/dev/properties/v1', subData);
      if (res.code === 0) {
        this.datalist = res.data.properties
      } else {
        if (res.code == '100410') {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="scss"></style>
